import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SHHETS_CONFIG } from "./sheets.config";
import { consultRegisteredIntegrations } from "../../../services/api/Integrations/listRegisteredIntegrations";
import { isFeatureAllowed } from "../../../shared/utils/featureAccess";
import {
  normalizeIntegrationValue,
  resolveIntegrationIcon,
  resolveIntegrationKey,
  resolveIntegrationTitle,
} from "../../../shared/constants/integrations";

const ERP_DEFAULT_FEATURES = [
  "Sincronização automática",
  "Listagens em tempo real",
  "Integração direta com o sistema",
  "Atualização contínua das informações",
];



function mapERPToSheetOption(erp) {
  const integrationKey = resolveIntegrationKey(erp.integration_title);
  const integrationTitle = resolveIntegrationTitle(erp.integration_title);

  return {
    key: `erp_${integrationKey || normalizeIntegrationValue(integrationTitle)}`,
    title: integrationTitle,
    subtitle: "Integração ERP",
    text: "Crie listagens diretamente a partir do seu ERP integrado.",
    icon: erp.integration_logo || resolveIntegrationIcon(erp.integration_title),
    tag: "ERP",
    route: integrationKey ? `/listagens/adicionar/${integrationKey}` : "/listagens/adicionar",
    status: erp.status,
    features: ERP_DEFAULT_FEATURES
  };
}

function uniqueErpsByProvider(items = []) {
  const byProvider = new Map();

  items.forEach((item) => {
    const title = item?.integration_title;
    const key = resolveIntegrationKey(title) || normalizeIntegrationValue(title);
    if (!key || byProvider.has(key)) return;
    byProvider.set(key, item);
  });

  return Array.from(byProvider.values());
}


export function useSheetsOptions(featureAccess) {
  const navigate = useNavigate();
  const [erpOptions, setErpOptions] = useState([]);
  const [isLoadingErp, setIsLoadingErp] = useState(false);

  useEffect(() => {
    setIsLoadingErp(true);
    consultRegisteredIntegrations()
      .then((response) => {
        const mapped = uniqueErpsByProvider(response.data).map(mapERPToSheetOption);
        setErpOptions(mapped);
      })
      .catch(() => {
        setErpOptions([]);
      })
      .finally(() => {
        setIsLoadingErp(false);
      });
  }, []);

  const baseOptions = SHHETS_CONFIG.filter(
    (i) => i.key !== "add_integration"
  );

  const addIntegration = SHHETS_CONFIG.find(
    (i) => i.key === "add_integration"
  );

  const mergedOptions = [
    ...baseOptions,
    ...erpOptions,
    addIntegration,
  ].filter(Boolean);

  const sheetsData = mergedOptions.map((template) => ({
    ...template,
    alreadyPaid:
      isFeatureAllowed(featureAccess, template.key, true) ||
      (template.tag === "ERP" && isFeatureAllowed(featureAccess, "ERP", true)),
    handleClick: () => navigate(template.route),
  }));

  return { sheetsData, isLoadingErp };
}
